import React from 'react';

//Material
import { Grid, Paper, Typography } from '@mui/material';
// import { Stack } from '@mui/system';
import { connect } from 'react-redux';
import '../../pages/MainPage/index.css';
import { LetsGoBtn } from '../Buttons';
import { useNavigate } from 'react-router-dom';
import Illustration from '../../assets/Banners/illustration1.png';
// import  ImageGallery  from 'react-image-gallery';

// const useStyles = makeStyles({

//   button: {
//     '&:hover': {
//       boxShadow: '-5px 5px 3px black !important',
// width: '155px !important'
//   },
// }})
function Banner2() {
  const navigate = useNavigate();
  return (
    <Paper
      // {...props}
      // key={}
      // className="serviceCard"
      sx={{
        width: '100%',
        maxWidth: '809px',
        margin: '0px',
        textAlign: 'center',
        overflow: 'hidden',
        alignItems: 'center',
        boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
        borderRadius: '16px',
        padding: '16px ',
        border: '2px solid #E2F2FF !important',
        backgroundColor: 'white',
        backgroundImage: `url(${Illustration})`,
        position: 'relative',
        backgroundSize: 'contain',
        height: { xs: 'unset', sm: '212px' }
      }}
    >
      <Grid
        container
        spacing={0}
        sx={{
          width: '100%',
          margin: '0px !important',
          height: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          p: '8px',
          borderRadius: '8px'
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'start',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <Typography
            variant="p"
            sx={{
              margin: '0px',
              wordBreak: 'break-word',
              fontFamily: 'FixelText-Medium !important',
              fontWeight: 500,
              fontSize: { xs: '20px', sm: '24px' },
              textAlign: 'center',
              mt: 2
            }}
          >
            Перейдіть на новий рівень з
            <Typography
              variant="p"
              sx={{
                fontFamily: 'FixelText-Medium !important',
                fontWeight: 500,
                fontSize: { xs: '20px', sm: '24px' },
                color: '#60A5DF'
              }}
            >
              {' '}
              Преміум
            </Typography>
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontSize: { xs: '14px', sm: '16px' }, textAlign: 'left', mt: 1 }}
          >
            Ваш комфорт без зайвих турбот
          </Typography>
          <LetsGoBtn
            colorScheme="blue"
            width="200px"
            margin="15px 0px 0px 0px"
            text="Стати Преміум"
            onClick={() => {
              navigate(`/ua/tariffs`);
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale
  };
};
export default connect(mapStateToProps)(Banner2);
